export enum RuleOperators {
    blank = 380,
    notBlank = 381,
    changes = 382,
    increases = 383,
    decreases = 384,
    equal = 385,
    differsFrom = 386,
    greaterThan = 387,
    greaterOrEqual = 388,
    lessThan = 389,
    lessOrEqual = 390,
    fallsBetween = 391
}

export enum OldZoomValues {
    choose = 'choose',
    search = 'search',
    date = 'date'
}
